import orderArrayBy from "./genericArraySorter";

export function getTopFives(inputList, nutrient, lowest) {
  let topList = [];
  inputList.forEach((item) => {
    if (item.nutrients) {
      if (item.nutrients !== "") {
        item.nutrients.forEach((currentNutrient) => {
          if (currentNutrient.name === nutrient) {
            topList.push({
              name: item.name,
              amount: currentNutrient.amount,
              unit_id: currentNutrient.unit_id,
            });
          }
        });
      }
    }
  });
  orderArrayBy(topList, "amount", lowest);
  return topList.slice(0, 5);
}
